<template>
  <div>
    <el-form-item label="" prop="fileList">
      <!-- action 行动 -->
      <el-upload
        class="upload-demo"
        :action="uploadUrl"
        :on-change="changeUpload"
        :on-preview="getfile"
        :on-remove="removefile"
        :on-success="successfile"
        :on-error="errorfile"
        :before-remove="beforeRemove"
        :headers="headers"
        :file-list="fileList"
        :auto-upload="true"
        :before-upload="beforuploadfile"
        ref="fileRef"
        list-type="picture"
      >
        <el-button size="small" type="primary">上传图片</el-button>
      </el-upload>
    </el-form-item>
  </div>
</template>
<script>
import env from "../../env";
import { obs_upload_delete } from "../../api/api";
export default {
  name: "upload-image",
  props: {
    fileListArr: "",
  },
  data() {
    return {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      }, // 文件上传header
      uploadUrl: env.basUrl + "/api/obs-upload-set", // 文件上传url
      fileList: [], // 文件上传列表
      urlPath: { path: "" }, // 文件上传url对象
      dialogVisible: false,
      fileinfo: "",
      filename: "",
    };
  },
  created() {
    if (
      typeof this.fileListArr != "undefined" &&
      this.fileListArr
    ) {
      console.log("图片数据", this.fileListArr);
      JSON.parse(this.fileListArr).forEach((item) => {
        let reg = /^http/;
        if (!item.response) {
          this.filename = JSON.parse(this.fileListArr).file_name;
          let obj = {
            name: item.file_name,
            url: item.file_path,
          };
          // console.log(obj)
          this.fileList.push(obj);
        } else {
          if (reg.test(item.response.path)) {
            this.filename = JSON.parse(this.fileListArr).file_name;
            let obj = {
              name: item.name,
              url: item.response.path,
            };
            this.fileList.push(obj);
          } else if (reg.test(item.response.file_path)) {
            this.filename = JSON.parse(this.fileListArr).file_name;
            let obj = {
              name: item.name,
              url: item.response.file_path,
            };
            this.fileList.push(obj);
          } else {
            this.$message.error("不能正常显示图片");
          }
        }
      });
      return;
    }
  },
  methods: {
    changeUpload(file, fileList) {
    },
    successfile(file, fileLise) {
      console.log('图片',fileLise)
      if(fileLise.response.msg=='图片上传成功！'){
        this.$message.success('封面图片上传成功')
        this.$emit("setImgFun", [fileLise]);
      }else{
        this.$message.error(fileLise.response.msg);
      }
    },
    errorfile(file, fileLise) {
      this.$message.error(file.msg);
    },
    getfile(file) {
      // window.open("/file-upload-get?path=" + file.response.path);
    },
    removefile(file, fileList) {},
    beforeRemove(file, fileList) {
      obs_upload_delete({ file_name: this.filename }).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        if (data.code == 204) {
          this.$message.success(data.msg);
          this.$emit("setImgFun", "");
        }
      });
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforuploadfile(file) {
      let kb = file.size / 1024 / 1024;
      let type = file.type.split("/")[1];
      if (type == "png") {
        if (kb >= 3) {
          this.$message.error("png图片不能大于3M，请转为jpg上传");
          return false;
        }
      } else {
        if (kb >= 5) {
          this.$message.error("jpg图片不能大于5M，请压缩后在上传");
          return false;
        }
      }
    },
    dataURLtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>